<template>

    <div class="congratz-step">
        <div class="back-vis">
            <div class="one"></div>
            <div class="two"></div>
            <div class="three"></div>
        </div>
        <div class="content">
            <div class="front-vis"></div>
            <div class="inn-content">
                <span class="caption ft-xbld txt-grt">Congrats, all is done! </span>
                <p>Thank you for trusting BEE Selfcare, we just sent you all information into your mailbox.</p>
                <router-link tag="a" to="/dashboard" class="btn main lrg gbck">
                    <span class="hvr"></span>
                    <span class="txt">Go to the administration page</span>
                </router-link>
            </div>
        </div>
    </div>

</template>

<script>

    export default {

        name: 'Congrats',

        data() {
            return {
            }
        }

    }

</script>